import CreateCourseHeader from './CreateCourseHeader';
import { CreateCourseHeaderProps, CreateCourseHeaderValueProps } from './types';

export type { CreateCourseHeaderProps, CreateCourseHeaderValueProps };
export default CreateCourseHeader;
